import { msalInstance } from '../settings/authSettings';
import { useEffect, useState } from 'react';
import * as microsoftTeams from "@microsoft/teams-js";
import { useSearchParams } from 'react-router-dom';
import * as msal from "@azure/msal-browser";
import { Spinny } from '../components/Spinny';

export default function SilentEnd() {
    useEffect(() => {
        microsoftTeams.app.initialize().then(() => {



            msalInstance.handleRedirectPromise(window.location.hash).then((tokenResponse) => {
                const currentAccounts = msalInstance.getAllAccounts();
                if (!currentAccounts || currentAccounts.length === 0) {
                    microsoftTeams.authentication.notifyFailure("Unable to login");
                    return;
                } else {
                    microsoftTeams.authentication.notifySuccess();
                }
            })
                .catch((error) => {
                    console.log(error);
                    microsoftTeams.authentication.notifyFailure(error);
                    return;
                });
        });
    }, []);

    return <div><Spinny text={`Silent-End: Processing sign-in response…`} />
    </div>;
}